import { lazy } from "react";

const Clientes = lazy(() => import("../../../features/clientes/ClientesPage"));
const NovoCliente = lazy(() => import("../../../pages/cliente/novoCliente"));
const EditarCliente = lazy(() => import("../../../pages/cliente/editarCliente"));
const VincularVeiculo = lazy(() => import("../../../features/clientes/pages/VincularVeiculoPage"));
const VisualizarVeiculoVinculado = lazy(() => import("../../../features/clientes/pages/VeiculosVinculadosPage"));

export const clientRoutes = [
  { path: "/cliente", component: Clientes, private: true },
  { path: "/novoCliente", component: NovoCliente, private: true },
  { path: "/novoCliente/:companyId", component: NovoCliente, private: true },
  { path: "/editarCliente/:clientId", component: EditarCliente, private: true },
  { path: "/veiculos/:clientId", component: VincularVeiculo, private: true },
  { path: "/visualizarVeiculoVinculado/:clientId", component: VisualizarVeiculoVinculado, private: true },
];
